























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import RateCardDto from '@/models/RateCards/RateCardDto';
import CreateRateCardRequest from '@/models/RateCards/CreateRateCardRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'AgencyRateCardCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new CreateRateCardRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateRateCardRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
       
    await AgencySettingsModule.createRateCard(this.entity)
    this.dialog = false;
  }
}
